import React from 'react';
import { IconProps } from '../../types/icons';
import './icon.scss';

const PlaneTopIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="planetopicon"
      viewBox="0 0 96 120"
    >
      <path d="M92.048,49.229L57.792,30.36V9.8c-0.004-5.408-4.396-9.8-9.8-9.8c-5.4,0-9.796,4.392-9.796,9.796v20.556L3.944,49.22  c-0.624,0.345-1.012,1.005-1.012,1.716v7.84c0,0.589,0.268,1.156,0.732,1.541c0.472,0.367,1.076,0.512,1.652,0.384l32.892-7.312  v20.268L23.104,88.939c-0.368,0.369-0.572,0.856-0.572,1.377v3.728c0,0.628,0.3,1.228,0.816,1.584  c0.508,0.376,1.168,0.468,1.768,0.269L48,88.271l22.893,7.625c0.207,0.067,0.407,0.092,0.615,0.092c0.412,0,0.813-0.12,1.148-0.372  c0.504-0.376,0.812-0.96,0.812-1.584v-3.74c0-0.521-0.2-1.008-0.571-1.38l-15.104-15.28V53.364l32.892,7.308  c0.572,0.128,1.188-0.008,1.656-0.384c0.456-0.376,0.736-0.933,0.736-1.532v-7.84C93.061,50.229,92.668,49.568,92.048,49.229  L92.048,49.229z" fill={fill || '#7E8A96'} />
    </svg>
  );
};

export default PlaneTopIcon;
